import { Button } from '../../../components/button'

export default function UpdateEmailRequestSuccess({ onClose }) {
  return (
    <div className='wrapper'>
      <h1 className='title'>Success!</h1>
      <p className='description'>Your password has been updated</p>

      <Button className='CTA' onClick={onClose}>
        Close
      </Button>

      <style jsx>{`
        .wrapper {
          position: relative;
          width: 43.6rem;
          padding: 2.6rem 0 4.1rem;
          background: #fff;
          border-radius: 1rem;

          :global(.CTA) {
            display: block;
            margin: 0 auto;
          }
        }

        .title {
          text-align: center;
          font-size: 3.2rem;
        }

        .description {
          max-width: 26.6rem;
          margin: 0.7rem auto 2.6rem;
          text-align: center;
          font-size: 1.6rem;
        }

        @media (max-width: 1024px) {
          .wrapper {
            width: 100%;
            height: 100%;
            padding: 3.6rem 0 2.3rem;

            :global(.CTA) {
              position: fixed;
              bottom: 2.1rem;
              left: 1.2rem;
              width: calc(100vw - 2.4rem);
            }
          }

          .title {
            font-size: 1.8rem;
          }

          .description {
            line-height: 1.9rem;
            font-size: 1.4rem;
          }
        }
      `}</style>
    </div>
  )
}
